var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"toast"},[_c('i'),_vm._v(_vm._s(_vm.loadingMsg || "加载中，请稍候...")+"\n\t")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }